export default __webpack_public_path__ + "static/media/calendar.bf045aae.svg";